import type { TRouteDefinition, TRouteNames } from './types'

// Keep this catalog free of runtime component imports so navigation helpers stay lightweight.
export const routes = {
  // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-[ GENERAL ]
  homePage: {
    title: 'Home Page',
    path: '/',
    section: 'pages',
    preResolve: true,
    authenticated: false,
  },
  locationHome: {
    title: '',
    path: '/:accountName',
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  signIn: {
    title: 'Sign In',
    path: '/:accountName/signin',
    section: 'noHeaderPages',
    preResolve: true,
    authenticated: false,
  },
  searchServiceType: {
    title: 'Booking Home',
    path: '/:accountName/search/:serviceTypeName/pets',
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  searchOffersResults: {
    title: 'Offers Search Results',
    path: '/:accountName/search/:serviceTypeName/offers',
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  searchRoomAddOns: {
    title: 'Offer Room AddOns',
    path: '/:accountName/search/:serviceTypeName/room-addons',
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  searchPetAddOns: {
    title: 'Offer Pet AddOns',
    path: '/:accountName/search/:serviceTypeName/pet-addons',
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  bookingArrivalDepartures: {
    title: 'Arrivals & Departures',
    path: '/:accountName/booking/arrival-departures',
    section: 'offers',
    preResolve: false,
    authenticated: true,
  },
  loginCheck: {
    title: 'Pet Owner Verification',
    path: '/:accountName/search/:serviceTypeName/verification',
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  detailsPolicies: {
    title: 'DetailsAndPolicies',
    path: '/:accountName/booking/details-policies',
    section: 'offers',
    preResolve: false,
    authenticated: true,
  },
  waitlistConfirm: {
    title: 'Waitlist Confirm',
    path: '/:accountName/booking/waitlist',
    section: 'pages',
    preResolve: false,
    authenticated: true,
  },
  contactToBook: {
    title: 'Contact Us To Book',
    path: '/:accountName/search/:serviceTypeName/contact-to-book',
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  purchaseHistory: {
    title: 'Purchase History',
    path: '/:accountName/account/bookings/purchases',
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  purchaseSummary: {
    title: 'Purchase Summary',
    path: '/:accountName/account/bookings/:bookingId',
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  purchaseHistory_legacy: {
    title: 'Purchase History',
    path: `/kennels/:accountName/bookings`,
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  purchaseSummary_legacy: {
    title: 'Purchase Summary',
    path: `/kennels/:accountName/bookings/:bookingId/:shortId`,
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  purchaseSummaryCancel_legacy: {
    title: 'Purchase Summary',
    path: `/kennels/:accountName/cancel-reservation/:bookingId`,
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  rest_legacy: {
    title: '',
    path: `/kennels/:accountName/*`,
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  datesSelection: {
    title: 'Dates Selection',
    path: '/:accountName/search/:serviceTypeName/dates',
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  temperTest: {
    title: 'Temperamental Test',
    path: '/:accountName/search/:serviceTypeName/temper-test',
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  groomingWizard: {
    title: 'Grooming Wizard',
    path: '/:accountName/search/:serviceTypeName/grooming',
    section: 'offers',
    preResolve: false,
    authenticated: true,
  },
  paymentForm: {
    title: 'Payment',
    path: '/:accountName/booking/payment',
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  paymentSummary: {
    title: 'Payment Summary',
    path: '/:accountName/booking/confirmation/:orderId',
    section: 'offers',
    preResolve: false,
    authenticated: false,
  },
  privacyPolicy: {
    title: 'Privacy Policy',
    path: '/:accountName/privacy-policy',
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
  profile: {
    title: '',
    path: '/:accountName/profile',
    section: 'pages',
    preResolve: false,
    authenticated: true,
  },
  myprofile: {
    title: 'MyProfile',
    path: '/:accountName/profile/my-profile',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  myprofileEdit: {
    title: 'MyProfile',
    path: '/:accountName/profile/my-profile/edit',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profilePet: {
    title: 'Profile Pet',
    path: '/:accountName/profile/pets',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profilePetEdit: {
    title: 'Profile Pet',
    path: '/:accountName/profile/pets/:lppId',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profilePetAdd: {
    title: 'Profile Add',
    path: '/:accountName/profile/pets/add',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileCameras: {
    title: 'Profile Cameras',
    path: '/:accountName/profile/cameras',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileBookings: {
    title: 'Profile Bookings',
    path: '/:accountName/profile/bookings',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileWaitlist: {
    title: 'Profile Waitlist',
    path: '/:accountName/profile/waitlist',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileReportCards: {
    title: 'Profile Report Cards',
    path: '/:accountName/profile/report-cards',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profilePayments: {
    title: 'Profile Payments',
    path: '/:accountName/profile/payments',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileMemberships: {
    title: 'Profile Memberships',
    path: '/:accountName/profile/memberships',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profilePackages: {
    title: 'Profile Packages',
    path: '/:accountName/profile/packages',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileAgreements: {
    title: 'Profile Agreements',
    path: '/:accountName/profile/agreements',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileContracts: {
    title: 'Profle Agreements',
    path: '/:accountName/profile/contracts/:contractId',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileContacts: {
    title: 'Profile Contacts',
    path: '/:accountName/profile/contacts',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileContactsEdit: {
    title: 'Profile Contacts Edit',
    path: '/:accountName/profile/contacts/:contactId',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  profileContactsAdd: {
    title: 'Profile Contacts Add',
    path: '/:accountName/profile/contacts/add',
    section: 'profile',
    preResolve: false,
    authenticated: true,
  },
  notFound: {
    title: 'Not Found',
    path: '/:accountName/not-found',
    section: 'pages',
    preResolve: false,
    authenticated: false,
  },
} satisfies Record<string, TRouteDefinition>

export const routeKeys = Object.keys(routes) as TRouteNames[]
